import { withStyles } from '@material-ui/core';
import Label from './common/Label';
import Detail from './common/Detail';
import appConstants from '../../../../../appConstants';
import { getFeetInchesDisplayValue } from '../DriverPopUp/utils';

const styles = () => ({
  detailsContainer: {
    marginTop: 8,
    '&>div:last-child': {
      marginTop: 8
    }
  },
  container: {
    margin: '16px 0px'
  }
});
const ExcessiveLength = ({
  classes,
  excessiveLength,
  excessiveLengthFeet,
  excessiveLengthInches,
  isPickupPro = false
}) => {
  const displayValue = getFeetInchesDisplayValue(excessiveLengthFeet, excessiveLengthInches);

  return (
    <div className={classes.container}>
      <Label labelText="EXCESSIVE LENGTH" />
      <div className={classes.detailsContainer}>
        {!isPickupPro && (
          <Detail
            label="Does the Pro have Excessive length?"
            value={excessiveLength === appConstants.EXCESSIVE_SHIPMENT.YES ? 'Yes' : 'No'}
            isFullWidth
          />
        )}
        {excessiveLength === appConstants.EXCESSIVE_SHIPMENT.YES ? (
          <Detail label="Pro length" value={displayValue} isFullWidth />
        ) : (
          isPickupPro && <Detail label="Pro length" value='NA' isFullWidth />
        )}
      </div>
    </div>
  );
};

export default withStyles(styles)(ExcessiveLength);
